export default __webpack_public_path__ + "static/media/banner-treatment-symbol-big.8f6aabc3.svg";